import React from "react";
import RealMap from "../../Maps/RealMap";
import { Maximize2, X } from "lucide-react";

export default function MapPanel({
  tasks = [],
  drivers = [],
  teams = [],
  isMapZoomed,
  setIsMapZoomed,
}) {
  return (
    <>
      {/* ================= MINI MAP ================= */}
      {!isMapZoomed && (
        <div className="relative mt-3 h-[280px] w-full shrink-0 overflow-hidden rounded-xl border border-gray-200 bg-gray-100 shadow-sm">
          {/* Expand Button */}
          <button
            type="button"
            onClick={() => setIsMapZoomed(true)}
            className="absolute right-3 top-3 z-[999] flex h-9 w-9 items-center justify-center rounded-lg bg-white text-gray-900 shadow-lg transition hover:bg-gray-100"
            aria-label="Expand map"
          >
            <Maximize2 size={18} />
          </button>

          {/* Map */}
          <div className="h-full w-full">
            <RealMap
              Task={tasks}
              drivers={drivers}
              teams={teams}
              showSearch={false}
            />
          </div>
        </div>
      )}

      {/* ================= FULL SCREEN MAP ================= */}
      {isMapZoomed && (
        <div className="fixed inset-0 z-[99999] bg-black/60">
          <div className="relative h-full w-full bg-white">
            {/* Close Button */}
            <button
              type="button"
              onClick={() => setIsMapZoomed(false)}
              className="absolute right-4 top-4 z-[100000] flex h-10 w-10 items-center justify-center rounded-lg bg-red-500 text-white shadow-lg transition hover:bg-red-600"
              aria-label="Close map"
            >
              <X size={18} />
            </button>

            {/* Full Screen Map */}
            <div className="h-full w-full">
              <RealMap
                Task={tasks}
                drivers={drivers}
                teams={teams}
                showSearch={true}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
